<section
    class="padding-30px-tb xs-padding-60px-tb blog-style1 bg-light-deep-yellow  border-none header-margin-top-medium"
    id="">
    <div class="container">
        <!-- title -->
        <div class="row">
            <!-- title -->
            <h2
                class="title alt-font title-extra-large font-weight-500 sm-title-extra-large-2 xs-section-title-large text-brown margin-one-bottom text-center">
                Resúmen de Precios</h2>
            <h3
                class="title alt-font title-large sm-title-extra-large-2 xs-section-title-large text-dark-brown margin-five-bottom text-center">
                <div *ngIf="periodoActual"> {{periodoActual.descripcion}} </div>
            </h3>
            <!-- end  title -->
        </div>
        <div class="row">
            <div class="col-md-12 text-large bg-white margin-five-bottom">
                <table class="table precios">
                    <thead>
                        <tr>
                            <th scope="col">Lote</th>
                            <th scope="col">Vendedor</th>
                            <th scope="col">Dpto.</th>
                            <th scope="col">Categoría</th>
                            <th scope="col">Cantidad</th>
                            <th scope="col">Peso</th>
                            <th scope="col">Precio</th>
                            <th scope="col">Gs./Kg.</th>
                            <th scope="col">Ver ID</th>
                        </tr>
                    </thead>
                    <tbody *ngFor="let subasta of subastas">
                        <tr>
                            <td data-label="Lote: "> {{subasta.numero}} </td>
                            <td data-label="Vendedor: ">{{subasta.establecimiento.nombre}}</td>
                            <td data-label="Dpto.: ">{{subasta.establecimiento.departamento.descripcion}}</td>
                            <td data-label="Categoria: ">{{subasta.categoria}}</td>
                            <td data-label="Cantidad: ">{{subasta.cantidad}}</td>
                            <td data-label="Peso: ">{{subasta.peso}}</td>
                            <td data-label="Precio: ">{{separadorMiles(subasta.precioVentaFinal | number: '1.0-0') }}
                            </td>
                            <td data-label="Gs./Kg.: "> {{ separadorMiles(subasta.precioVentaFinal / subasta.peso |
                                number: '1.0-0')}}</td>
                            <td data-label="Ver ID"><a class="btn btn-small btn-circle propClone 
                              bg-dark-brown text-white text-medium" [routerLink]="['/subastas',subasta.identificador]"
                                    routerLinkActive="active"><span class="">{{subasta.identificador}}</span></a></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <h3
                class="title alt-font title-large sm-title-extra-large-2 xs-section-title-large text-dark-brown margin-five-bottom text-center">
                Historial de Precios</h3>
            <div class="col-lg-8 col-lg-offset-2 text-large  bg-white margin-five-bottom">
                <ng-multiselect-dropdown [placeholder]="'Elegir mes'" [data]="mesList" [settings]="dropdownSettings"
                    (onSelect)="onMesSelect($event)" [(ngModel)]="selectedMes">
                </ng-multiselect-dropdown>
                <ng-multiselect-dropdown [placeholder]="'Elegir año'" [data]="anhoList" [settings]="dropdownSettings"
                    (onSelect)="onAnhoSelect($event)" [(ngModel)]="selectedAnho">
                </ng-multiselect-dropdown>
                <table class="table" style="width: 100%;">
                    <tbody>
                    </tbody>
                    <caption>
                        <h4 *ngIf="mes && anho ">{{mes.item_text}} {{anho.item_text}}</h4>
                    </caption>
                    <tbody>
                        <tr *ngFor="let periodo of periodoFiltradoList">
                            <td> {{periodo.descripcion}} </td>
                            <td> <a class="btn btn-small btn-circle propClone bg-dark-brown text-white"
                                    [routerLink]="['/resumen-precios',periodo.id]" routerLinkActive="active"><span
                                        class="">VER RESUMEN</span></a>
                            </td>
                        </tr>
                        <tr *ngIf="loading && periodoFiltradoList.length === 0">
                            <td> No se encontraron periodos disponibles </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</section>
<section class="padding-50px-tb bg-light-deep-yellow  xs-padding-60px-tb feature-style-31 border-none" id="">
    <div class="separator-line1 width-80 bg-dark-brown center-col  margin-five-bottom sm-margin-ten-bottom"></div>
    <div class="container">
        <div class="row">
            <!-- feature box -->
            <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-fifteen-bottom">
                <div class=" display-table width-100">
                    <a routerLink="/como-funciona" routerLinkActive="active">
                        <div class="text-dark-brown icon-style margin-seven-right display-table-cell-vertical-middle">
                            <span class="fas fa-info-circle title-extra-large-2 "></span></div>
                        <div class="display-table-cell-vertical-middle ">
                            <span class="text-medium text-medium-gray ">Información</span>
                            <h3 class="text-large alt-font text-dark-gray ">Como funciona</h3>
                        </div>
                    </a>
                </div>
            </div>
            <!-- end feature box -->
            <!-- feature box -->
            <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-fifteen-bottom">
                <div class=" display-table width-100">
                    <a routerLink="/condiciones-subasta" routerLinkActive="active">
                        <div class="text-dark-brown icon-style margin-seven-right display-table-cell-vertical-middle">
                            <span class="fas fa-gavel title-extra-large-2 "></span></div>
                        <div class="display-table-cell-vertical-middle ">
                            <span class="text-medium text-medium-gray ">Participar de subastas</span>
                            <h3 class="text-large alt-font text-dark-gray ">Condiciones</h3>
                        </div>
                    </a>
                </div>
            </div>
            <!-- end feature box -->
            <!-- feature box -->
            <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-fifteen-bottom">
                <div class=" display-table width-100">
                    <a routerLink="/login" routerLinkActive="active">
                        <div class="text-dark-brown icon-style margin-seven-right display-table-cell-vertical-middle">
                            <span class="fas fa-address-card title-extra-large-2 "></span></div>
                        <div class="display-table-cell-vertical-middle ">
                            <span class="text-medium text-medium-gray ">Únase hoy mismo</span>
                            <h3 class="text-large alt-font text-dark-gray ">Registro</h3>
                        </div>
                    </a>
                </div>
            </div>
            <!-- end feature box -->
            <!-- feature box -->
            <div class="col-md-3 col-sm-4 col-xs-12 xs-margin-fifteen-bottom">
                <div class=" display-table width-100">
                    <a routerLink="/login" routerLinkActive="active">
                        <div class="text-dark-brown icon-style margin-seven-right display-table-cell-vertical-middle">
                            <span class="fas fa-sign-in-alt title-extra-large-2 "></span></div>
                        <div class="display-table-cell-vertical-middle ">
                            <span class="text-medium text-medium-gray ">¿Ya está registrado?</span>
                            <h3 class="text-large alt-font text-dark-gray ">Ingresar</h3>
                        </div>
                    </a>
                </div>
            </div>
            <!-- end feature box -->
        </div>
    </div>
</section>
